import PrivateLayout from '@/layouts/PrivateLayout.vue';
import UsersPage from '@/pages/UsersPage.vue';
import ProfilePage from '@/pages/ProfilePage.vue';

export default [
  {
    path: '/users',
    component: PrivateLayout,
    children: [
      {
        path: '',
        name: 'Users',
        component: UsersPage,
        meta: { roles: ['superuser', 'user'] },
      },
      {
        path: 'profile/:id',
        name: 'Profile',
        component: ProfilePage,
      },
    ],
    meta: { requiresAuth: true },
  },
];
